import style from "./style.module.scss"

import { Modal, Headline3, Text } from "ui-kit/components-branded/index"
import { MODAL_THEMES } from "ui-kit/components-branded/Modal/contants"

interface ContactsModalProps {
    isModalShown: boolean
    hideModal: () => void
    onLinkClick: () => void
}

export function ConnectionStatusModal({
    isModalShown,
    hideModal,
    onLinkClick,
}: ContactsModalProps) {
    return (
        <Modal onBackgroundClick={hideModal} isActive={isModalShown} theme={MODAL_THEMES.DARK}>
            <Modal.Content
                heading={
                    <Headline3 className={style.connectionStatusModal__title}>
                        Плохое соединение
                    </Headline3>
                }
                onCloseClick={hideModal}
                data-testid="connection-status-modal"
            >
                <div className={style.connectionStatusModal__note}>
                    <Text>Возможно зыпаздывание видео или звука.</Text>
                </div>
                <div className={style.connectionStatusModal__text}>
                    <Text>Что может помочь решить проблему:</Text>
                    <ol>
                        <li>
                            <Text>Если вы используете wi-fi, расположитесь ближе к роутеру</Text>
                        </li>
                        <li>
                            <Text>
                                Смените сеть, например wi-fi на мобильный интернет и наоборот
                            </Text>
                        </li>
                        <li>
                            <Text>Отключите видео</Text>
                        </li>
                        <li>
                            <Text>Попросите собеседника отключить видео</Text>
                        </li>
                    </ol>
                </div>
                <div className={style.connectionStatusModal__footer}>
                    <Text>
                        <b>Если проблему не удалось решить</b>
                    </Text>
                    <br />
                    <span>
                        <Text>Попробуйте </Text>
                        <Text>
                            <a
                                className={style.connectionStatusModal__footerLink}
                                onClick={onLinkClick}
                            >
                                альтернативный способ связи
                            </a>
                            .
                        </Text>
                    </span>
                </div>
            </Modal.Content>
        </Modal>
    )
}
